import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { NonlistedcallDataModal } from '../../model'
import { Router } from '@angular/router'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-nonlistedcall',
    template: require('./nonlistedcall.component.html'),
    styles: []
})
export class NonListedCallComponent implements OnInit {
    private columnDefs;
    private rowHeight;
    firstDate: string;
    lastDate: string;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    POBReport_show: boolean = false;
    nonListedData: any = [];
    empName: any = [];
    token:any;
    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }
    
    NonlistedcallData: NonlistedcallDataModal = new NonlistedcallDataModal();

    Nonlistedcall_Form = new FormGroup({
        fromDate: new FormControl('', [Validators.required]),
        toDate: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        hq: new FormControl('', [Validators.required]),
        employee: new FormControl('', [Validators.required]),
        product_group: new FormControl('', [Validators.required]),
        product_code: new FormControl('', [Validators.required]),

    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
        this.columnDefs = [
            // { headerName: 'Sr. No', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Sr. No', valueGetter: params => { return params.data.DCR_Date? params.node.rowIndex + 1: "" }, width: 80 },
            { headerName: 'DCR Date', field: "DCR_Date", suppressSizeToFit: true },
            { headerName: 'Employee Code', field: "employee_code" },
            { headerName: 'Employee Name', field: "Client_Name" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'State', field: "StateName" },
            { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'Chemist name', field: "ChemistName" },
            { headerName: 'Mobile Number', field: "mobile" },
            { headerName: 'Time', field: "Time" },
            { headerName: 'POB', field: "POB", cellStyle: { 'textAlign': "right" } },
            { headerName: 'submit Area', field: "SubmitArea", cellStyle: { 'textAlign': "right" } },
            { headerName: 'DL No.', field: "DL No", cellStyle: { 'textAlign': "right" } },

        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }



    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        var totalRow = { 
            "Client_Name": "Total: 0" ,
            "POB": (0).toFixed(2)
        };
        setTimeout(()=>{
            this.api.setPinnedBottomRowData([totalRow])
        }, 300);
        this.getEmployee();
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.Nonlistedcall_Form.controls['fromDate'].setValue(
            this.firstDate
        );
        this.Nonlistedcall_Form.controls['toDate'].setValue(
            this.lastDate
        );
        this.NonlistedcallData.employeeCode = '0';
        this.NonlistedcallData.Type = '0';

    }


    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'Non-ListedCall_Report' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }


    getEmployee() {
        var data = {
            Id: this.token.id
        };
        this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    getNonListedCall() {
        this.NonlistedcallData.fromDate = this.Nonlistedcall_Form.value.fromDate;
        this.NonlistedcallData.toDate = this.Nonlistedcall_Form.value.toDate;
        this.NonlistedcallData.LoginId = this.token.id;
       // console.log(this.NonlistedcallData);
        this.busy = this.apiService.getNonListedCall(this.NonlistedcallData).subscribe((res: any) => {
            this.nonListedData = res.data;
            var parent =this;
            var POB = this.nonListedData.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.POB)); }, 0);
            var totalRow = { 
                POB: POB.toFixed(2),
                "Client_Name": "Total: " + this.nonListedData.length
            };
            setTimeout(()=>{
                this.api.setPinnedBottomRowData([totalRow]);
            }, 300);
        })
    }
}
